export const FETCH_LOCATION_DATA = "FETCH_LOCATION_DATA";
